import FirebaseWrite from "@/services/database/firebaseWrite";
import {BewerbRundeTab} from "@/services/data/meisterschaften/bewerbRundeTab";
import {BewerbRundeKo} from "@/services/data/meisterschaften/bewerbRundeKo";
import TimeStamp from "@/services/timeStamp";

export class Bewerb {
    constructor(bewerb, lvId, ligaId, spielTyp, sportJahr, meisterschaftName, meisterschaftType) {
        // on changes always update getDataObjectForFirebase
        this.id = bewerb?.id??null;
        if ( bewerb?.deletedBy ) this.deletedBy = bewerb?.deletedBy
        this.settings = {
            bewerbTyp: bewerb?.settings?.bewerbTyp??null,
            modus: bewerb?.settings?.modus??null,
            anzahlStarterMax: bewerb?.settings?.anzahlStarterMax??null, //aus const BEWERB_ANZAHL_STARTER außer Modus "tabelle"
            teamsToKoMax: bewerb?.settings?.teamsToKoMax??null, // aus const BEWERB_ANZAHL_STARTER
            rankingPlatz3bis4: bewerb?.settings?.rankingPlatz3bis4??null,
            rankingPlatz5bis8: bewerb?.settings?.rankingPlatz5bis8??null,
            lvId: bewerb?.settings?.lvId??lvId,
            ligaId: bewerb?.settings?.ligaId??ligaId,
            tabs: bewerb?.settings?.tabs?? {},
            spiel: bewerb?.settings?.spiel??{
                saetze: null,
                wuerfeProSatz: null,
                dauerGeplant: '00:00',
            },
            spielTyp: bewerb?.settings?.spielTyp??spielTyp,
            sportJahr: bewerb?.settings?.sportJahr??sportJahr,
            status: bewerb?.settings?.status??'pending',
            statusChangeLog: bewerb?.settings?.statusChangeLog??[],
            meisterschaftName: bewerb?.settings?.meisterschaftName??meisterschaftName,
            meisterschaftType: bewerb?.settings?.meisterschaftType??meisterschaftType,
            datum: bewerb?.settings?.datum??null,
            ort: bewerb?.settings?.ort??null,
            bahn: bewerb?.settings?.bahn??null,
            schiedsrichter: bewerb?.settings?.schiedsrichter??null,
            liveStream: bewerb?.settings?.liveStream??null,
        }
        this.setRunden(bewerb?.runden)
        // on changes always update getDataObjectForFirebase
    }

    setRunden(runden){
        this.runden = {}
        if ( runden ) {
            Object.values(runden).forEach( (runde) => {
                this.runden[runde.id] = runde.settings.modus === 'tabelle' ?
                    new BewerbRundeTab(runde, runde.id, runde.settings) :
                    new BewerbRundeKo(runde, runde.id, runde.settings)
            })
        }
        // on changes always update getDataObjectForFirebase
    }

    getNumberOfRunden() {
        return Object.keys(this.runden).length;
    }

    getDataObjectForFirebase() {
        return {
            settings: this.settings,
            runden: JSON.parse(JSON.stringify(this.runden))
        }
    }

    async create(documentId) {
        this.id = documentId
        this.initRundenForNewBewerb();
        return await FirebaseWrite.set("meisterschaftenBewerbe", documentId,
                                        this.getDataObjectForFirebase());
    }

    async update(updateObject) {
        return await FirebaseWrite.update("meisterschaftenBewerbe", this.id, updateObject);
    }

// getters
    getInfoText() {
        const infoArray = []
        if ( this.settings.datum ) infoArray.push(this.settings.datum)
        if ( this.settings.bahn ) infoArray.push(this.settings.bahn)
        if ( this.settings.ort ) infoArray.push(this.settings.ort)
        if ( this.settings.schiedsrichter ) infoArray.push("Schiedsrichter: " + this.settings.schiedsrichter)
        return infoArray.join(', ')
    }

    getKoTeilnehmer() {
        return this.settings.teamsToKoMax??this.settings.anzahlStarterMax;
    }

    getKoRunden() {
        return Object.values(this.runden).filter( (runde) => runde.settings.modus !== 'tabelle');
    }

    getTabs(sortRundenIds) {
        const tabs = Object.values(this.settings.tabs).sort((a,b) => a.id - b.id);
        if ( sortRundenIds ) {
            tabs.forEach( (tab) => tab.rundenIds = this.getSortedRundenIdsForTab(tab.id))
        }
        return tabs
    }
    getSortedRundenIdsForTab(tabId) {
        const rundenIds = JSON.parse(JSON.stringify(this.settings?.tabs?.[tabId]?.rundenIds))
        return rundenIds.sort((a, b) => a > b ? 1 : -1);
    }
    getTeamLabel() {
        return {
            singular: this.settings.spielTyp === 'einzel' ? 'Person' : 'Team',
            plural: this.settings.spielTyp === 'einzel' ? 'Personen' : 'Teams'
        }
    }
    getPreviousRunde(rundeId) {
        return this.runden[rundeId - 10];
    }
    getRundenNameFromTab(rundeId) {
        return Object.values(this.settings.tabs).find( (tab) => tab.rundenIds.includes(rundeId))?.title;
    }
    isConfirmed() {
        return this.settings.status === 'confirmed'
    }
    rankingPlatz5bis8Required(teamsToKoMax) {
        return (this.settings.modus === 'ko' && this.settings.anzahlStarterMax > 4 ) ||
               (this.settings.modus === 'tabelle_ko' && teamsToKoMax > 4)
    }
    rankingPlatz3bis4Required(teamsToKoMax) {
        return (this.settings.modus === 'ko' && this.settings.anzahlStarterMax > 2 ) ||
               (this.settings.modus === 'tabelle_ko' && teamsToKoMax > 2)
    }

// add tab runde
    async addTabRunde(rundenName) {
        const tabs = JSON.parse(JSON.stringify(this.settings.tabs))
        const totalRunden = Object.keys(this.runden).length;
        const newRundeId = (totalRunden * 10) + 10;
        const rundenArr = JSON.parse(JSON.stringify(Object.values(this.runden)));
        const runden = {}
        rundenArr.forEach( (runde) => {
            runden[runde.id] = new BewerbRundeTab(runde, runde.id, this.settings)
        });
        runden[newRundeId+''] = new BewerbRundeTab(null, newRundeId, this.settings);
        runden[newRundeId+''].settings.name = rundenName
        if ( totalRunden===1 ) tabs['0'] = this.setTab(0, 'Qualifikation', [10])
        tabs[totalRunden+''] = this.setTab(totalRunden, rundenName, [newRundeId])
        await this.updateTabRundenChange(newRundeId,
                                 JSON.parse(JSON.stringify(runden[newRundeId+''])),
                                tabs)
        this.runden = runden;
        this.settings.tabs = tabs
    }
    async editTabRunde(rundenId, rundenName) {
        const tabs = JSON.parse(JSON.stringify(this.settings.tabs))
        const tabId = rundenId/10 - 1
        tabs[tabId].title = rundenName
        this.settings.tabs = tabs
        this.runden[rundenId].settings.name = rundenName
        await this.update({
            ['runden.' + rundenId + '.settings.name']: rundenName,
            ['settings.tabs']: this.settings.tabs
        })
    }
    async deleteTabRunde(rundenId){
        delete this.runden[rundenId]
        let tabs = JSON.parse(JSON.stringify(this.settings.tabs))
        const tabId = rundenId/10 - 1
        if ( tabId === 1 ) {
            tabs = {}
        } else {
            delete tabs[tabId]
        }
        this.settings.tabs = tabs
        await this.updateTabRundenChange(rundenId, 'firebase.firestore.FieldValue.delete()')
    }
    async updateTabRundenChange(rundenId, rundenObj, settingsTabs){
        const runden = JSON.parse(JSON.stringify(this.runden))
        this.setRunden(runden);
        await this.update({
            ['runden.' + rundenId]: rundenObj,
            ['settings.tabs']: settingsTabs ? settingsTabs : this.settings.tabs
        })
    }

// init runden from selected modus
    initRundenForNewBewerb() {
        this.runden = {};
        // IMPORTANT: es muss immer eine Runde 10 geben (und das ist immer die erste)
        switch (this.settings.modus) {
            case "tabelle":
                this.runden['10'] = new BewerbRundeTab(null, 10, this.settings);
                break;
            case "tabelle_ko":
                this.runden['10'] = new BewerbRundeTab(null, 10, this.settings);
                this.runden['10'].settings.modus = 'tabelle';
                this.initKoRunden(10)
                this.setTabs(true)
                break;
            case "ko":
                this.initKoRunden(null)
                this.setTabs(false)
                break;
        }
    }

    initKoRunden(qualiRundeId) {
        let starter = this.getKoTeilnehmer()
        let spielId = 1;
        let rundeId = qualiRundeId ? qualiRundeId + 10 : 10;
        do {
            this.runden[rundeId] = new BewerbRundeKo(
                null, rundeId, this.settings, starter / 2
            )
            this.runden[rundeId].settings.modus = 'ko';
            spielId = this.runden[rundeId].initSpiele( spielId,
                                                        starter===2 && this.settings.rankingPlatz3bis4==='ko');
            starter = starter / 2;
            rundeId = rundeId + 10;
        } while ( starter > 1 )
    }

    setTabs(hasQualiRunde) {
        const koRunden = this.getKoRunden().sort((a, b) => a.settings.anzahlSpiele - b.settings.anzahlSpiele);
        const anzahlKoRunden = koRunden.length;
        const fixeRundenIds = koRunden.filter( (runde) => runde.settings.anzahlSpiele <=4).map( (runde) => runde.id);
        let runde = 1, id = hasQualiRunde ? 1 : 0
        if ( anzahlKoRunden > 3 ) {
            for ( let i = anzahlKoRunden; i > 3; i-- ) {
                this.settings.tabs[id] = this.setTab(id, (runde) + '. Runde ', [koRunden[i-1].id])
                runde ++; id ++
            }
        }
        this.settings.tabs[id] = this.setTab(id, 'Finalrunden', fixeRundenIds)
        if ( hasQualiRunde ) this.settings.tabs[0] = this.setTab(0, 'Qualifikation', [10])
    }

    setTab(id, title, rundenIds){
        return { id, title, rundenIds}
    }

    async updateRundenSettings(runde) {
    // update in datebase
        const reply = await FirebaseWrite.update("meisterschaftenBewerbe", this.id,
            {['runden.' + runde.id + '.settings']: runde.settings}
        );
    // update in local data
        if ( reply.successful ) {
            const rundeTemp = this.runden[runde.id];
            rundeTemp.settings = runde.settings;
            this.runden[runde.id] = runde;
        }
    // return
        return reply
    }

    async changeStatus(userId){
        const newStatus = this.settings.status === 'confirmed'? 'pending' : 'confirmed';
        const reply = await FirebaseWrite.update('meisterschaftenBewerbe', this.id,
            {['settings.status']: newStatus,
                ['settings.statusChangeLog']: {
                    action: 'arrayUnion',
                    value: {ts: TimeStamp.getGMTTimestamp(), userId: userId, newStatus: newStatus},
                }
            }
        )
        if ( reply.successful ) this.settings.status = newStatus
        return reply
    }
// Endergebnis
    getEndergebnis() {
        const runden = Object.values(this.runden)
        const anzahlPlaetze = this.settings.modus === 'ko' ?
            this.settings.anzahlStarterMax > 8 ? 8 : this.settings.anzahlStarterMax :
            this.settings.teamsToKoMax > 8 ? 8 : this.settings.teamsToKoMax;
        const endergebnis = {}
        for ( let i = 1; i <= anzahlPlaetze; i++ ) endergebnis[i] = {platz: i, team: null, kegel: 0, class: ''}
    // finale
        this.getEndergebnisFinale(endergebnis, runden)
    // platz 3 + 4
        if ( anzahlPlaetze > 2 && this.settings.rankingPlatz3bis4 !== 'ko' ) {this.getEndergebnisVorFinale(
            endergebnis, runden, 2,
            this.settings.rankingPlatz3bis4 === 'exAequo'
        )} else if ( anzahlPlaetze > 2 && this.settings.rankingPlatz3bis4 === 'ko' ) this.getEndergebnisFromSpielUmPlatz3(
            endergebnis, runden, 2,
            this.settings.rankingPlatz3bis4 === 'exAequo'
        )
    // platz 5 - 8
        if ( anzahlPlaetze > 4 ) this.getEndergebnisVorFinale(
            endergebnis, runden, 4,
            this.settings.rankingPlatz5bis8 === 'exAequo'
        )
    // format endergebnis
        this.cssFormatEndergebnis(endergebnis, anzahlPlaetze)
    // return
        return endergebnis
    }
        cssFormatEndergebnis(endergebnis, anzahlPlaetze) {
            endergebnis[1].class = 'gold'
            endergebnis[2].class = 'silver'
            endergebnis[3].class = 'bronze'
            if ( this.settings.rankingPlatz3bis4 === 'exAequo' && anzahlPlaetze >= 4 ) {
                endergebnis[4].platz = 3
                endergebnis[4].class = 'bronze'
            }
            if ( endergebnis[4].platz === 3 ) endergebnis[4].class = 'bronze'
            if ( this.settings.rankingPlatz5bis8 === 'exAequo' && anzahlPlaetze >= 8 ) {
                for ( let i = 5; i <= 8; i++ ) endergebnis[i].platz = 5
            }
        }

        getEndergebnisFinale(endergebnis, runden) {
            const finalRunde = runden.find( (runde) => runde.settings.anzahlSpiele === 1)
            if ( finalRunde ) {
                const finalSpielId = this.settings.rankingPlatz3bis4 === 'ko' ? 1 : 0
                const finalSpiel = Object.values(finalRunde.spiele)[finalSpielId]
                if ( finalSpiel.winner ) {
                    endergebnis[1].team = finalSpiel[finalSpiel.winner]
                    endergebnis[2].team = finalSpiel.winner === 'team1' ? finalSpiel.team2 : finalSpiel.team1
                }
            }
        }

        getEndergebnisFromSpielUmPlatz3(endergebnis, runden) {
            const finalRunde = runden.find( (runde) => runde.settings.anzahlSpiele === 1)
            if ( finalRunde ) {
                const spielUmPlatz3 = Object.values(finalRunde.spiele)[0]
                if ( spielUmPlatz3.winner !== 'freilos' ) {
                    endergebnis[3].team = spielUmPlatz3[spielUmPlatz3.winner]
                    endergebnis[4].team = spielUmPlatz3.winner === 'team1' ? spielUmPlatz3.team2 : spielUmPlatz3.team1
                } else {
                    endergebnis[3].team = spielUmPlatz3.team1
                    endergebnis[4].team = spielUmPlatz3.team2
                    endergebnis[4].platz = 3
                }
            }
        }

        getEndergebnisVorFinale(endergebnis, runden, anzahlSpiele, exAequo) {
            const runde = runden.find( (runde) => runde.settings.anzahlSpiele === anzahlSpiele)
            const spiele = Object.values(runde.spiele)
            let verlierer = []
            spiele.forEach( (spiel) => {
                if ( spiel.winner ) {
                    const verliererKey = this.getSpielVerliererKey(spiel)
                    if (verliererKey) verlierer.push(
                        {team: spiel[verliererKey], kegel: exAequo ? 0 : this.getVerliererKegel(spiel, verliererKey)}
                    )
                }
            });
            if ( exAequo ) {
                verlierer = verlierer.filter( (verlierer ) => verlierer.team!==null)
                verlierer.sort((a,b) => a.team?.settings?.name > b.team?.settings?.name ? 1 : -1)
            } else {
                verlierer.sort((b,a) => a.kegel > b.kegel ? 1 : -1)
            }
            const platzMin = 1 + anzahlSpiele
            const platzMax = platzMin + anzahlSpiele - 1
            for ( let i = platzMin; i <= platzMax; i++ ) {
                if ( verlierer[i-platzMin]?.team ) {
                    endergebnis[i].team = verlierer[i-platzMin].team
                    endergebnis[i].kegel = verlierer[i-platzMin].kegel
                    if ( i>platzMin && endergebnis[i].kegel === endergebnis[i-1].kegel ) {
                        endergebnis[i].platz = endergebnis[i-1].platz
                    }
                }
            }
        }

            getSpielVerliererKey(spiel) {
                return spiel.winner === 'freilos' ? null :
                       spiel.winner === 'team1' ? 'team2' : 'team1'
            }

            getVerliererKegel(spiel, verliererKey) {
                const kegelKey = verliererKey === 'team1' ? 'k1' : 'k2'
                let kegel = 0
                Object.values(spiel.saetze).forEach( (satz) => {
                    kegel += isNaN(satz[kegelKey]) ? 0 : satz[kegelKey]
                });
                return kegel
            }
}